module.exports = __webpack_public_path__ + "img/PEDRO.b37aa8bf.jpeg";